import { environment } from '../../../../environments/environment';

//signup-up
export const postSignup = `${environment.BaseAPI}user/signup`;

//signup-username
export const postUsernameData = `${environment.BaseAPI}user/username`;

//login
export const postSignIn = `${environment.BaseAPI}user/signin`;
export const forgetpassword = `${environment.BaseAPI}user/forgot`;
export const verifyOtp = `${environment.BaseAPI}user/verifyOtp`;
export const logoutApi = `${environment.BaseAPI}user/logout`;

//resetPassword
export const newForgetpassword = `${environment.BaseAPI}user/verifyOtp/changePassword`;

//google-login
export const googlePostLogin = `${environment.BaseAPI}user/google-login`;

//profile
export const profileData = `${environment.BaseAPI}user/profile`;
export const profilestatusData = `${environment.BaseAPI}user/updateStatus`;
export const profileupdateData = `${environment.BaseAPI}user/updateProfile`;
export const changespassword = `${environment.BaseAPI}user/changePassword`;
export const profileUpload = `${environment.BaseAPI}user/updateProfilePic`;
export const completedgames = `${environment.BaseAPI}game/completedGames`;
export const deletegames = `${environment.BaseAPI}game/deleteGame`;


//friends
export const playerFind = `${environment.BaseAPI}user/findPlayers`;
export const friendFind = `${environment.BaseAPI}user/findFriends`;
export const friendReq = `${environment.BaseAPI}user/frndReq`;
export const friendAcceptReq = `${environment.BaseAPI}user/acceptReq`;
export const friendRejectReq = `${environment.BaseAPI}user/rejectFrndReq`;
export const removefriends = `${environment.BaseAPI}user/removefriend`;
export const reqeustlist = `${environment.BaseAPI}user/requestList`;
export const cancelFriendReq = `${environment.BaseAPI}user/cancelFriendReq`;
export const allPlayerID = `${environment.BaseAPI}user/players`;

// play-chess
export const gameCreate = `${environment.BaseAPI}game/create`;
export const gamejoingame = `${environment.BaseAPI}game/joingame`;
export const endgame = `${environment.BaseAPI}game/endgame`;
export const UpdateRatings = `${environment.BaseAPI}game/newRatings`;

//puzzle
export const puzzleData = `${environment.BaseAPI}puzzle/getPuzzles`;
export const puzzlefinishData = `${environment.BaseAPI}puzzle/solvePuzzle`;
export const puzzlecountData = `${environment.BaseAPI}puzzle/puzzlesCount`;
export const puzzlecomplated = `${environment.BaseAPI}puzzle/playedPuzzles`;
export const puzzledaily = `${environment.BaseAPI}puzzle/dailyPuzzle`;

//proplayergames
export const proplayers = `${environment.BaseAPI}database/players`;
export const playersGames = `${environment.BaseAPI}database/playedGames`;
export const playerSuggestion = `${environment.BaseAPI}database/playerSuggestions`;

//notiification
export const notifications = `${environment.BaseAPI}user/notifications`;

//token-expire
export const tokenExpire = `${environment.BaseAPI}user/checkToken`;

//ratings
export const playerRating = `${environment.BaseAPI}user/ratings`;

//leaderBoard
export const Leaderboard = `${environment.BaseAPI}user/leaderBoard`;
export const Rankboard = `${environment.BaseAPI}user/rankBoard`;
export const myRanking = `${environment.BaseAPI}user/myRankings`;

//boardPiece
export const boardpiece = `${environment.BaseAPI}user/updateBoardPiece`;
export const getboardpiece = `${environment.BaseAPI}user/boardPiece`;
export const setTheme = `${environment.BaseAPI}user/updateTheme`;

//openings
export const openings = `${environment.BaseAPI}opening/openings`;
export const openingsuggestion = `${environment.BaseAPI}opening/openingSuggestions`;

//opening-id
export const openingId = `${environment.BaseAPI}opening/openingsByMove`;

//contact-us
export const contactUs = `${environment.BaseAPI}others/contactUS`;
export const BlogData = `${environment.BaseAPI}others/blogs`;
export const Bloginsert = `${environment.BaseAPI}others/insertblog`;
export const BlogdetailsData = `${environment.BaseAPI}others/blog-details`;